import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeleteConfirmationModalComponent } from '../modals';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-interest-table-component',
    templateUrl: './interest-component.html',
    styleUrls: ['./interest-component.scss']
})

export class InterestTableComponent implements OnInit {
    @Input() data_array : Array<any>;
    @Output() delete = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();

    constructor(private modalService: NgbModal) {
    	
    }

    ngOnInit() {}

    deleteAction(data){
        const modalRef = this.modalService.open(DeleteConfirmationModalComponent);
              const p1 = data.job.job_title_en
              modalRef.componentInstance.Title = p1;
              modalRef.result.then((result) => {
                    if(result.status)
                        this.delete.emit(data.id);
                  }).catch((error) => {
              });
        
    }

    editAction(data){
        this.edit.emit({... data});
    }
}



